// extracted by mini-css-extract-plugin
module.exports = {"container":"_2lnPEpRL_ChVzg9026VnO-","primaryLigth":"_1fpYOb8WU4enL-aBAq59QS","darkGradient":"_2nPuFPBYraK3Hgj0qKJsiv"};